/**
 * SPEC-AgentList-Hardening — single source of truth for the ops day boundary.
 *
 * Mirrors `server/lib/time.ts`'s `OPS_TZ` constant for client-side display
 * purposes (e.g. formatting a "today" timestamp). Deliberately a separate
 * file: neither side should import from the other.
 *
 * Acceptance: the literal string `"America/Toronto"` must appear in exactly
 * two source files (this file and `server/lib/time.ts`).
 */
export const OPS_TZ = "America/Toronto" as const;
